import { Card, CardBody, Col } from "reactstrap";
import { ContextualClasse, Href } from "../../../../Constant";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { CONTEXTUAL_DATA, CONTEXTUAL_LIST } from "../../../../Data/UiKit/Lists";
import { LI, UL } from "../../../../AbstractElements";

const ContextualClasses = () => {
  return (
    <Col xl="6" sm="12" className="box-col-6">
      <Card className="height-equal">
        <CommonCardHeader title={ContextualClasse} span={CONTEXTUAL_DATA} />
        <CardBody>
          <UL>
            <LI tag="a" href={Href} className="list-group-item-action list-light-primary">
              This is Primary bg you can use <em className="txt-primary fw-bold">.list-light-primary</em> class.
            </LI>
            {CONTEXTUAL_LIST.map((item, index) => (
              <LI tag="a" href={Href} className={`list-group-item-action list-light-${item}`} key={index}>
                This is <span className="text-capitalize">{item}</span> bg you can use <em className={`txt-${item} fw-bold`}>.list-light-{item}</em> class.
              </LI>
            ))}
          </UL>
        </CardBody>
      </Card>
    </Col>
  );
};

export default ContextualClasses;